import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {RoamingPartnersModel} from "../../models/roaming-partners.model";
import {UserVerificationService} from "../../services/user-verification.service";
import {Location} from "@angular/common";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {KeycloakService} from "../../services/keycloak.service";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-roaming-partners',
  templateUrl: './create-roaming-partners.component.html',
})
export class CreateRoamingPartnersComponent implements OnInit {
  public roamingPartnersModel: RoamingPartnersModel;
  public title;
  public nsName;
  public nsId;
  public roamingPolicyType;
  public searchText = '';
  public allNetworks: any[] = [];
  public allNSWithVirtId: any[] = [];
  public showSearch = false;
  public isEnable = false;
  private username: string = KeycloakService.username;
  private value:any = {};

  public selectedOwner(value:any):void {
    this.searchText = value.split(",").splice(0)[0];
    this.isEnable = true;
    for(let nsValue of this.allNSWithVirtId) {
      if(nsValue.name == this.searchText){
        this.roamingPartnersModel.partnersNS = nsValue.virtId;
      }
    }
  }

  public removed(value:any):void {
    this.isEnable = false;
  }

  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private route: ActivatedRoute,
              userVerificationService: UserVerificationService,
              private _location: Location,
              private http: HttpClient) {

    this.roamingPartnersModel = new RoamingPartnersModel();
  }

  verifyRoamingPolicy(){
    if(this.roamingPartnersModel.roamingPolicy == "Unrestricted Peering") {
      this.roamingPolicyType = "UP";
    } else {
      this.roamingPolicyType = "BP";
    }
  }

  getAllNSWithSearch(virtId){
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_WOR;
    var body = {
      "virtID" : virtId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};

    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            if(index.virtId !== this.roamingPartnersModel.nS){
              this.allNetworks.push(index.name + ", " + index.netIds.toString());
              this.allNSWithVirtId.push(index);
            }
          }
        }
      );
  }

  updateModelOnOwnPRAChanged() {
    if(this.roamingPartnersModel.ownDevices == true) {
      this.roamingPartnersModel.partnersRole.fNS = true;
    }
  }
  updateModelOnPartnerPRAChanged() {
    if(this.roamingPartnersModel.partnerDevice == true) {
      this.roamingPartnersModel.partnersRole.sNS = true;
    }
  }
  updateModelOnFnsChanged() {
    if(this.roamingPartnersModel.partnersRole.fNS == false) {
      this.roamingPartnersModel.ownDevices = false;
    }
  }
  updateModelOnSnsChanged() {
    if(this.roamingPartnersModel.partnersRole.sNS == false) {
      this.roamingPartnersModel.partnerDevice = false;
    }
  }

  save(){
    this.verifyRoamingPolicy();
    var body: any = {
      "nsAid": this.roamingPartnersModel.nS,
      "nsBid": this.roamingPartnersModel.partnersNS,
      "roamingPolicyType": this.roamingPolicyType,
      "allowPRA_fromAtoB": this.roamingPartnersModel.ownDevices,
      "allowPRA_fromBtoA": this.roamingPartnersModel.partnerDevice,
      "allowPR_fromAtoB": this.roamingPartnersModel.partnersRole.fNS,
      "allowPR_fromBtoA": this.roamingPartnersModel.partnersRole.sNS,
      "ulThreshold_fromAtoB": Number(this.roamingPartnersModel.incomingUL),
      "ulThreshold_fromBtoA": Number(this.roamingPartnersModel.outgoingUL),
      "dlThreshold_fromAtoB": Number(this.roamingPartnersModel.incomingDL),
      "dlThreshold_fromBtoA": Number(this.roamingPartnersModel.outgoingDL)
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = ApiEndpoints.CREATE_ROAMING_AGREEMENT;

    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }
  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    this.getAllNSWithSearch(this.route.snapshot.queryParams["virtId"]);
    this.nsName = this.route.snapshot.queryParams["name"];
    this.nsId = this.route.snapshot.queryParams["id"].toString();
    this.roamingPartnersModel.nS = this.route.snapshot.queryParams["virtId"];

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

}
